import NoticeBar from './NoticeBar';

export default NoticeBar;
export { NoticeBar };
export type { NoticeBarProps, NoticeBarMode, NoticeBarInstance } from './interface';
